import { MASTER_RULE_SET } from "constants/actionTypes";

import { offlineCrudReducer } from "lib/reducers";
import { deserializeMasterRuleSet as deserializer } from "lib/serializers/masterRuleSets";

export const masterRuleSetReducer = offlineCrudReducer(MASTER_RULE_SET, {
  deserializer,
});
